module.exports = __webpack_public_path__ + "img/page2img2.4aac9b7d.png";